import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=86b3bab0"
import script from "./reset-password.js?vue&type=script&lang=js&external"
export * from "./reset-password.js?vue&type=script&lang=js&external"
import style0 from "./reset-password.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports